import SecureLS from 'secure-ls'

/**
 * Storage Keys.
 */
export const storgeKeys = {
    // 使用者記住帳密
    userRemember: 'hylAdmin.userRemember',
    // 使用者登入憑證
    userCredential: 'hylAdmin.userCredential'
};

/**
 * Secure LocalStorage.
 * @description https://varunmalhotra.xyz/secure-ls/
 */
export const secureStroge = new SecureLS({ encodingType: 'des', isCompression: false, encryptionSecret: 'i-love-hyl' });